
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { useAuthStore } from '../../stores/auth';
import { showVuePopup } from '../../utils/showVuePopup';
import Favorite from '../../popup/Favorite.vue';
import Recently from '../../popup/Recently.vue';

export default {
	name: 'GameNavbar',
	setup() {
		const auth = useAuthStore();
		auth.hydrate();
		const { profile } = storeToRefs(auth);

		const menus = ref([
			{ name: 'Demo', href: '/demo', image: 'https://placehold.co/400/webp?text=demo', show: false },
			{ name: 'Favorite', handle: () => showVuePopup(Favorite), image: 'https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/bgn-fav.webp', show: auth.isLoggedIn },
			{ name: 'Recently', handle: () => showVuePopup(Recently), image: 'https://rpg168.sgp1.cdn.digitaloceanspaces.com/theme/btn-recently.webp', show: auth.isLoggedIn },
			{ name: 'Recommended', href: '/recommended', image: 'https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/btn-play-m-hot.webp', show: auth.isLoggedIn },
			{ name: 'Slot', href: '/slot', image: 'https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/btn-tab-slot.webp', show: true },
			{ name: 'Casino', href: '/casino', image: 'https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/btn-tab-casnio.webp', show: true },
			{ name: 'Poker', href: '/poker', image: 'https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/btn-tab-poker.webp', show: true },
			{ name: 'Card', href: '/card', image: 'https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/btn-tab-card.webp', show: true },
			{ name: 'Fish Hunter', href: '/fishhunter', image: 'https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/btn-tab-fishhunter.webp', show: true },
			{ name: 'Lotto', href: '/lotto', image: 'https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/btn-tab-lotto.webp', show: true },
			{ name: 'Sport', href: '/sport', image: 'https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/btn-tab-sport.webp', show: true },
			{ name: 'Keno', href: '/keno', image: 'https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/btn-tab-keno.webp', show: true },
			{ name: 'Trade', href: '/trade', image: 'https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/btn-tab-trade.webp', show: true },
			{ name: 'Cockfighting', href: '/cockfighting', image: 'https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/btn-tab-ch.webp', show: true },
			{ name: 'E-Sport', href: '/esport', image: 'https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/btn-tab-esport.webp', show: true },
		]);

		return {
			profile,
			menus,
		};
	},
}
